import { UserType } from "utility/enums/user-type";

export enum UserStatus {
	Pending = 1,
	Active = 2,
	InActive = 3,
	Rejected = 4,
}

export interface LoginUserDetail {
	userId: number;
	fullName: string;
	name: string;
	surname: string;
	email: string;
	groups: string[];
	roles: string[];
	userTypeId: UserType;
	isUserFinanceManager: boolean;
	supplierId: number | null;
	isSupplierUserAdmin: boolean;
	departmentId: number | null;
	departmentName?: string;
	companyName?: string;
	// erpDbCompanyIds: number[];
}

export enum TokenStatus {
	Valid = 1,
	InValid = 2,
	Expired = 3,
}

export class IBaseToken {
	token: string = "";
	tokenExpiry: Date = new Date();
	refreshToken: string = "";
	refreshTokenExpiry: Date = new Date();
}

export interface IExternalUserLoginResponse extends IBaseToken {
	userDetails: LoginUserDetail;
	status: UserStatus;
}

export interface IRefreshTokenResponse extends IBaseToken {
	status: TokenStatus;
}
